import { Box, Link, Text } from 'native-base';
import React from 'react';
const WHAT_IS_AN_ESCROW = `
An escrow account allows Freedom Mortgage to pay your property taxes, homeowners insurance, and mortgage insurance when required. The money in your escrow account comes from your total mortgage payments.

Each year, we perform an escrow analysis to make sure the escrow portion of your monthly payment is enough to pay your property taxes and insurance premiums. This analysis also makes sure you maintain any minimum balance that may be required.

If your local taxing authority or insurance company changes the required payment, your monthly payment will also change accordingly. Freedom Mortgage does not determine these amounts. If you have questions about the amount due, please contact your taxing authority or insurance company. `;
const LEARN_MORE = `Learn More`;
const WHAT_IS_ESCROW = `What is escrow?`;
const EscrowDescription = _ref => {
  let {
    onLearnMoreClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    w: {
      base: 'full',
      md: 'full',
      lg: '2/3'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    fontSize: {
      base: 'sm',
      md: 'xl',
      lg: '2xl'
    },
    lineHeight: "lg",
    fontWeight: 'medium',
    accessibilityLabel: WHAT_IS_ESCROW,
    accessibilityRole: "text"
  }, WHAT_IS_ESCROW), /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    lineHeight: "lg",
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: WHAT_IS_AN_ESCROW,
    accessibilityRole: "text"
  }, WHAT_IS_AN_ESCROW, /*#__PURE__*/React.createElement(Link, {
    onPress: onLearnMoreClick,
    accessibilityLabel: LEARN_MORE,
    accessibilityRole: "link"
  }, LEARN_MORE)));
};
export default EscrowDescription;
//# sourceMappingURL=index.js.map